import { reactive, toRefs, computed } from '@vue/composition-api'
import axios from 'axios'
import useAlerts from '../../shared/composables/useAlerts'

let billing

export default function useBilling() {
  const { addAlert } = useAlerts()

  if (billing == undefined) {
    billing = reactive({
      card: {
        type: 'visa',
        name: '',
        number: '',
        lastFour: '',
        expirationMonth: '01',
        expirationYear: '2020',
        code: '',
      },
      cardErrors: [],
      po: {
        number: '',
        authorized: false,
        terms: false,
        comments: '',
        fob: '',
        creditBalance: 0,
      },
      poErrors: [],
      method: 'payCreditCard',
      // method: 'payPO',
      paymentOptions: [],
    })
  }

  const cardOptions = [
    // {name:"Visa", val:"visa", img:"visa.jpg"},
    // {name:"MasterCard", val:"mc", img:"mc.jpg"},
    // {name:"Discover", val:"disc", img:"disc.jpg"},
    // {name:"American Express", val:"amex", img:"amex.jpg"}
    { name: 'Credit Card', val: 'visa', img: 'visa.jpg' },
  ]

  const PODataComplete = () => {
    var po = billing.po
    return po.number != '' && po.authorized == true && po.terms == true && po.fob != ''
  }

  const cardDataComplete = () => {
    // var card = billing.card
    return (
      // card.type != '' &&
      // card.name != '' &&
      // card.number != '' &&
      // card.code != '' &&
      // card.expirationMonth != '' &&
      // card.expirationYear != '' &&
      // card.expirationMonth < 13 &&
      // card.expirationYear >= new Date().getFullYear()
      true
    )
  }

  const rot47 = (text) => {
    // Hides all ASCII-characters from 33 ("!") to 126 ("~").  Hence can be used
    // to obfuscate virtually any text, including URLs and emails.
    var R = new String()
    R = rotN(
      text,
      '!"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~'
    )
    return R
  }

  const rotN = (text, map) => {
    // Generic ROT-n algorithm for keycodes in MAP.
    var R = new String()
    var i,
      j,
      c,
      len = map.length
    for (i = 0; i < text.length; i++) {
      c = text.charAt(i)
      j = map.indexOf(c)
      if (j >= 0) {
        c = map.charAt((j + len / 2) % len)
      }
      R = R + c
    }
    return R
  }

  const encryptField = (value, field) => {
    if (value != undefined) {
      billing.card[field] = rot47(value)
      if (field == 'number') {
        billing.card['lastFour'] = computed(() => value.substr(value.length - 4, 4))
      }
    }
  }

  const getPaymentOptions = () => {
    return axios
      .get('/actions/checkout.cfc?method=getPaymentOptions')
      .then(function(response) {
        billing.paymentOptions = response.data
      })
      .catch((error) => {
        addAlert('An error occurred loading payment options.', 'alert-danger', 7000)
        console.log(error)
      })
  }

  // const validateCardInfo = (number) => {
  const validateCardInfo = () => {
    // billing.cardErrors = []
    // billing.cardErrors.push(checkRequiredFields())
    // billing.cardErrors.push(checkCardType())
    // billing.cardErrors.push(checkExpirationDate())
    // billing.cardErrors.push(checkSecurityCode())
    // billing.cardErrors.push(checkCardNumber(number))
    // billing.cardErrors = billing.cardErrors.filter((error) => {
    //   return error != undefined
    // })
  }

  // const checkRequiredFields = () => {
  //   for (let field in billing.card) {
  //     if (billing.card[field] == '') {
  //       return 'Payment information is missing or incomplete.'
  //     }
  //   }
  //   return
  // }

  // const checkCardType = () => {
  //   var matchedCardOption = cardOptions.find((option) => option.val == billing.card.type)
  //   if (!matchedCardOption) {
  //     return 'A card type of ' + billing.card.type + ' is not valid.'
  //   }
  //   return
  // }

  // const checkExpirationDate = () => {
  //   if (billing.card.expirationYear > new Date().getFullYear()) return
  //   if (billing.card.expirationMonth >= new Date().getMonth() + 1) return
  //   return 'The card expiration date must be in the future'
  // }

  // const checkSecurityCode = () => {
  //   return billing.card.code.search(/\d{3,4}/) > -1
  //     ? undefined
  //     : 'The card security code must be either three or four digits.'
  // }

  const getCustomerCreditBalance = () => {
    return axios
      .get('/actions/checkout.cfc?method=getCustomerCreditBalance')
      .then(function(response) {
        billing.po.creditBalance = response.data
      })
      .catch((error) => {
        addAlert('An error occurred loading credit balance.', 'alert-danger', 7000)
        console.log(error)
      })
  }

  //https://en.wikipedia.org/wiki/Luhn_algorithm
  // const checkCardNumber = (value) => {
  //   value = String(value)
  //   // Accept only digits, dashes or spaces
  //   if (/[^0-9-\s]+/.test(value)) return 'The credit card number provided is not valid.'

  //   // The Luhn Algorithm. It's so pretty.
  //   let nCheck = 0,
  //     bEven = false
  //   value = value.replace(/\D/g, '')

  //   for (var n = value.length - 1; n >= 0; n--) {
  //     var cDigit = value.charAt(n),
  //       nDigit = parseInt(cDigit, 10)

  //     if (bEven && (nDigit *= 2) > 9) nDigit -= 9

  //     nCheck += nDigit
  //     bEven = !bEven
  //   }

  //   return nCheck % 10 == 0 && value.search(/\d{13,16}/) > -1
  //     ? undefined
  //     : 'The credit card number provided is not valid.'
  // }

  return {
    ...toRefs(billing),
    cardDataComplete,
    encryptField,
    getPaymentOptions,
    validateCardInfo,
    getCustomerCreditBalance,
    PODataComplete,
    validPO: computed(() => PODataComplete()),
    cardOptions,
  }
}
